export const TRANSACTION_TIME_ZONE = "Asia/Jakarta";

export function transactionPeriod(preset, now = new Date()) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat("en", {
    timeZone: TRANSACTION_TIME_ZONE, year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(now).map(({ type, value }) => [type, value]));
  const today = `${parts.year}-${parts.month}-${parts.day}`;
  if (preset === "today") return { start: today, end: today };
  if (preset === "all") return { start: '', end: '' };
  if (preset === "yesterday") {
    const yesterday = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day) - 1)).toISOString().slice(0, 10);
    return { start: yesterday, end: yesterday };
  }
  const month = Number(parts.month) - 1 - (preset === "last-month" ? 1 : 0);
  const start = new Date(Date.UTC(Number(parts.year), month, 1)).toISOString().slice(0, 10);
  const end = new Date(Date.UTC(Number(parts.year), month + 1, 0)).toISOString().slice(0, 10);
  return { start, end };
}
